import React from 'react';
import { MessageCircle, Code } from 'lucide-react';
export function Footer() {
  return <footer className="bg-footer pt-16 pb-8" data-id="element-68">
      <div className="container mx-auto px-4" data-id="element-69">
        {/* Fila Superior */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-8" data-id="element-70">
          {/* Lado Izquierdo */}
          <div data-id="element-71">
            <h3 className="text-subtitle font-heading font-bold text-2xl mb-1 tracking-wide" data-id="element-72">
              2 DE ABRIL SRL
            </h3>
            <p className="text-subtitle/60" data-id="element-73">
              Reparación de equipos pesados · Mantenimiento & Servicios
            </p>
          </div>

          {/* Lado Derecho */}
          <div className="flex flex-col md:items-end gap-2" data-id="element-74">
            <div className="flex items-center gap-2 text-white font-medium" data-id="element-75">
              <MessageCircle className="w-5 h-5 text-whatsapp" data-id="element-76" />
              <span data-id="element-77">11 6127-9601 · 11 2170-7246</span>
            </div>
            <p className="text-subtitle/60 text-sm" data-id="element-78">
              [DIRECCIÓN] · [PROVINCIA] · ramonobregon377@gmail.com
            </p>
          </div>
        </div>

        {/* Línea Separadora */}
        <div className="w-full h-px bg-white/10 mb-8" data-id="element-79"></div>

        {/* Fila Inferior */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6" data-id="element-80">
          {/* Lado Izquierdo */}
          <div className="text-[13px] text-subtitle/50" data-id="element-81">
            © 2025 2 de Abril SRL · Todos los derechos reservados
          </div>

          {/* Lado Derecho */}
          <div className="flex items-start gap-3" data-id="element-82">
            <div className="w-10 h-10 rounded bg-primary flex items-center justify-center flex-shrink-0" data-id="element-83">
              <Code className="w-5 h-5 text-accent" data-id="element-84" />
            </div>
            <div className="flex flex-col" data-id="element-85">
              <div className="text-[13px] text-white" data-id="element-86">
                Diseño web por{' '}
                <a href="mailto:Masterllcglobal@gmail.com" className="text-accent hover:underline transition-all" data-id="element-87">
                  Masterllcglobal@gmail.com
                </a>
              </div>
              <div className="text-[11px] text-subtitle/50 mt-0.5" data-id="element-88">
                Diseño y desarrollo de páginas web profesionales
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}